'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('@material-ui/core/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _styles = require('@material-ui/core/styles');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      margin: 'auto',
      width: '100px',
      height: '100px',
      fill: theme.palette.primary.main
    }
  };
};

var DrugsIcon = function DrugsIcon(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      rest = _objectWithoutProperties(_ref, ['className', 'classes']);

  var iconClasses = (0, _classnames2.default)(className, classes.root);
  return _react2.default.createElement(
    _SvgIcon2.default,
    _extends({
      className: iconClasses,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 320 279'
    }, rest),
    _react2.default.createElement('path', {
      d: 'M267.6 207.2a33.7 33.7 0 0 0-21.5-14.9l-1.5-.3 5.8-10.7a26.3 26.3 0 0 0-10.5-35.6l-2.1-1.1a25 25 0 0 0-11.3-3V72.7h3.8c4.2 0 7.7-3.4 7.7-7.7V24.1c0-4.2-3.4-7.7-7.7-7.7H121.2l-.3.1-.3-.1H65.7a7.7 7.7 0 0 0-7.7 7.7V65c0 4.2 3.4 7.7 7.7 7.7h3.8v162.5A24.8 24.8 0 0 0 94.3 260H192.5l.7-.1c2.1-.1 4.3-.3 6.4-.9a26.3 26.3 0 0 0 14-10.2 33 33 0 0 0 18 10.5l.9.1a34.3 34.3 0 0 0 35.1-52.2zM235.9 153a18 18 0 0 1 7.2 24.5l-7.8 14.3a34.5 34.5 0 0 0-26.5 17.6c-1.3-.6-2.7-1-4-1.8a36.6 36.6 0 0 1-11.3-9.2c-2.1-2.8-2.8-5.3-1.9-6.8l17.6-32.4a18 18 0 0 1 10.8-8.7 18 18 0 0 1 13.8 1.4l2.1 1.1zm-61 52.3H78V95.4h140.2v47l-.5.1c-6.7 2-12.3 6.5-15.6 12.6l-27.2 50.2zm25.5-180.7v39.9h-20.5V24.6h20.5zm-28.7 39.9h-20.5V24.6h20.5v39.9zm-28.7 0h-20.5V24.6H143v39.9zm-28.7 0H93.8V24.6h20.5v39.9zm115.9 0h-21.6v-40l21.1-.4.5 40.4zM65.7 24.6h19.9v39.9h-8.5c-.6 0-1.1.2-1.6.3l-9.3.2-.5-40.4zm27.4 48.1h27.4l.3-.1.3.1h97.1v14.6H77.1V72.7h16zM77.6 235.2l-.1-21.7h92.9l-3.6 6.6a26.3 26.3 0 0 0 4.6 31.2l.7.5h-78c-9 0-16.5-7.4-16.5-16.6zm105.8 14.5l-2.1-1.1c-1.5-.8-2.9-1.9-4.1-3a18 18 0 0 1-3.1-21.5l6.3-11.6a4 4 0 0 0 1.2-2.3l4.6-8.4 1 1.6c3.2 4.3 8.1 8.3 13.8 11.4 1.6.9 3.2 1.4 4.8 2.1l-.5 1.6a33.7 33.7 0 0 0 3.2 22.9l-.6 1a18.2 18.2 0 0 1-24.5 7.3zm33.5-9.8c-3.8-5.8-5-12.8-3.5-19.6a26.4 26.4 0 0 1 25.4-20.5l1.5.2-10.9 50c-5.2-2-9.5-5.4-12.5-10.1zm47.4-8.6a26.6 26.6 0 0 1-26.9 20.4l10.9-50.1a25.8 25.8 0 0 1 16 29.7z'
    }),
    _react2.default.createElement('path', {
      d: 'M177.4 134.5H166v-11.4c0-4-3.2-7.2-7.2-7.2h-21.6c-4 0-7.2 3.2-7.2 7.2v11.4h-11.4c-4 0-7.2 3.2-7.2 7.2v21.6c0 4 3.2 7.2 7.2 7.2H130V182c0 4 3.2 7.2 7.2 7.2h21.6c4 0 7.2-3.2 7.2-7.2v-11.4h11.4c4 0 7.2-3.2 7.2-7.2v-21.6c0-4.1-3.2-7.3-7.2-7.3zm-1 27.9h-14.6a4 4 0 0 0-4.1 4.1V181H138v-14.6a4 4 0 0 0-4.1-4.1h-14.6v-19.7H134a4 4 0 0 0 4.1-4.1V124h19.7v14.6a4 4 0 0 0 4.1 4.1h14.6l-.1 19.7z'
    })
  );
};

exports.default = (0, _styles.withStyles)(styles)(DrugsIcon);